import React, { useContext } from "react";
import { Radio } from "components/Form/Field";
import { IntlContext } from "context";

interface Props {
    disabled: boolean;
    isAd: boolean;
}

const HandiworkFields: React.FC<Props> = ({ disabled, isAd }) => {
    const intl = useContext(IntlContext);

    return (
        <div className="grid--2 grid--small-1 grid--has-gutter-5x margin-top--3">
            <Radio
                fieldControlProps={{
                    className: "field-control-radio field__row--inline",
                }}
                inputProps={{
                    name: "data.bring_tools",
                    required: true,
                    disabled: disabled,
                    options: [
                        {
                            label: intl.formatMessage("generic.label.yes"),
                            value: "1",
                        },
                        {
                            label: intl.formatMessage("generic.label.no"),
                            value: "0",
                        },
                    ],
                }}
                labelProps={{
                    label: isAd ? intl.formatMessage("ad.label.bring_yes") : intl.formatMessage("service.label.bring"),
                }}
            />
        </div>
    );
};

export default HandiworkFields;
